import e from "react";
import { useTranslation as B } from "react-i18next";
import g from "classnames";
import { useStyle as V } from "../../../dom/hooks/useStyle.js";
import { StampCardStatus as r } from "../../../../../common/shared/loyalty/stampcard.js";
import { getDateTimeWithMonthName as q } from "../../../../utils.js";
import { LoyaltyProgress as z } from "../LoyaltyProgress/LoyaltyProgress.js";
import { LoyaltyScanDisplay as F } from "../LoyaltyScanDisplay/LoyaltyScanDisplay.js";
import { AddToWallet as U } from "../AddToWallet/AddToWallet.js";
import a from "./stampCard.module.scss.js";
import { Modal as X } from "../Modal/Modal.js";
function ae(f) {
  const {
    status: s,
    tierName: y,
    footNote: o,
    terms: l,
    customerName: v,
    currencyName: x,
    expiredText: T,
    completeText: S,
    cycleEndText: b,
    expirationDate: c,
    fontFamily: m,
    cardSize: d = 300,
    backgroundColor: k,
    cardColor: n,
    contentTextColor: i,
    accentColor: I,
    maxProgressValue: p,
    progressBackgroundColor: D,
    progressBackgroundImage: L,
    progressBarColor: M,
    progressStampImage: h,
    progressValue: _,
    progressType: P,
    qrData: w,
    qrScanType: W,
    walletUrl: C,
    forceWallet: O,
    standalone: E
  } = f, { t } = B(), [R, u] = e.useState(!1);
  V(`https://fonts.googleapis.com/css?family=${encodeURIComponent(m)}&display=swap`);
  const N = [r.COMPLETE, r.EXPIRED].includes(s);
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      "data-testid": "stamp-card",
      className: g({
        [a.cardWrapper]: !E,
        [a.standalone]: E
      }),
      style: {
        fontFamily: m,
        "--backgroundColor": k,
        "--cardColor": n,
        "--contentTextColor": i,
        "--accentColor": I,
        "--cardSize": `${d}px`
      }
    },
    /* @__PURE__ */ e.createElement(
      "div",
      {
        className: a.stampCard
      },
      /* @__PURE__ */ e.createElement(
        z,
        {
          type: P,
          maxValue: p,
          value: _,
          backgroundColor: D,
          backgroundImage: L,
          maxWidth: d,
          progressBarColor: M,
          stampImage: h ?? ""
        },
        s === r.EXPIRED && (T || t("stampCard.expired")),
        s === r.CYCLE_END && (b || t("stampCard.cycleEnd")),
        s === r.COMPLETE && (S || t("stampCard.complete"))
      ),
      /* @__PURE__ */ e.createElement("div", { className: a.stampCard__scanCode }, /* @__PURE__ */ e.createElement(
        F,
        {
          disabled: N,
          type: W,
          data: w
        }
      )),
      /* @__PURE__ */ e.createElement("div", { className: a.stampCard__profile }, /* @__PURE__ */ e.createElement("div", { className: a.stampCard__profile__tierName }, y), /* @__PURE__ */ e.createElement("div", { className: a.stampCard__profile__customerName }, v)),
      /* @__PURE__ */ e.createElement("div", { className: a.stampCard__status }, /* @__PURE__ */ e.createElement("div", { className: a.stampCard__status__details }, /* @__PURE__ */ e.createElement("div", { className: a.stampCard__status__details__currencyName }, x || t("points")), /* @__PURE__ */ e.createElement("div", { className: a.stampCard__status__details__progress }, _, "/", p)), c && /* @__PURE__ */ e.createElement("div", { className: a.stampCard__status__expiration }, t("stampCard.expirationLabel"), " ", q(c))),
      C && /* @__PURE__ */ e.createElement(
        "div",
        {
          className: g({
            [a.stampCard__wallet]: !0,
            [a.stampCard__wallet__disabled]: N
          })
        },
        /* @__PURE__ */ e.createElement(U, { force: O, url: C })
      ),
      o && /* @__PURE__ */ e.createElement("div", { className: a.stampCard__footNote }, o)
    ),
    l && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
      "div",
      {
        onClick: () => u(!0),
        className: a.terms
      },
      t("terms.title")
    ), /* @__PURE__ */ e.createElement(
      X,
      {
        show: R,
        onClose: () => u(!1),
        design: {
          backgroundColor: n,
          textColor: i,
          fontFamily: m
        }
      },
      /* @__PURE__ */ e.createElement("div", { className: a.terms__modal }, /* @__PURE__ */ e.createElement("div", { className: a.terms__block }, /* @__PURE__ */ e.createElement("div", { className: a.terms__title }, t("terms.title")), /* @__PURE__ */ e.createElement(
        "div",
        {
          className: a.terms__text,
          dangerouslySetInnerHTML: {
            __html: l
          }
        }
      )))
    ))
  );
}
export {
  ae as StampCard
};
//# sourceMappingURL=StampCard.js.map
